import cx from "classnames";
import * as React from "react";
import * as spriv from "./CloseButton.module.css";

export function CloseButton(props: {
  onClick: () => void;
  color?: "light" | "dark";
}) {
  const theme = spriv[props.color ?? "light"];
  return (
    <button
      type="button"
      className={cx(spriv.button, theme)}
      onClick={props.onClick}
    >
      <svg width={16} height={16} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.988 1.599 14.389 0 7.994 6.395 1.599 0 0 1.599l6.395 6.395L0 14.389l1.599 1.599 6.395-6.395 6.395 6.395 1.599-1.599-6.395-6.395Z"
          className={cx(spriv.cross, theme)}
        />
      </svg>
    </button>
  );
}
